<script setup lang="ts">
const props = withDefaults(defineProps<{
    value?: number;
    max?: number;
    label?: string;
    valueLabel?: string;
    showValue?: boolean;
    showLabel?: boolean;
    inverse?: boolean;
}>(), {
    value: 0,
    max: 100,
    label: '',
    valueLabel: '',
    showValue: false,
    showLabel: true,
    inverse: false
});

const normalizedMax = computed(() => Math.max(1, props.max));
const normalizedValue = computed(() => Math.min(normalizedMax.value, Math.max(0, props.value)));
const percent = computed(() => normalizedValue.value / normalizedMax.value * 100);
const displayedValue = computed(() => props.valueLabel || `${Math.round(percent.value)}%`);
</script>

<template>
    <div class="flex min-w-0 flex-col gap-[6px]">
        <div v-if="(props.label && props.showLabel) || props.showValue" class="flex min-w-0 items-center justify-between gap-[10px] text-[0.75rem]/[1.35] font-[400]">
            <span v-if="props.label && props.showLabel" class="min-w-0" :class="props.inverse ? 'text-white/65 dark:text-fg-muted' : 'text-fg-muted dark:text-fg-muted-dark'">{{ $t(props.label) }}</span>
            <span v-if="props.showValue" class="ms-auto shrink-0 font-mono tabular-nums" :class="props.inverse ? 'text-white dark:text-fg' : 'text-fg dark:text-fg-dark'">{{ displayedValue }}</span>
        </div>
        <div
            class="h-[6px] overflow-hidden rounded-full" :class="props.inverse ? 'bg-white/15 dark:bg-border' : 'bg-surface-3 dark:bg-surface-3-dark'"
            role="progressbar"
            :aria-label="props.label ? $t(props.label) : undefined"
            aria-valuemin="0"
            :aria-valuemax="normalizedMax"
            :aria-valuenow="normalizedValue"
            :aria-valuetext="displayedValue"
        >
            <span
                class="block h-full rounded-full bg-accent transition-[width] duration-[0.3s] ease-in-out motion-reduce:transition-none"
                :style="{ width: `${percent}%` }"
            />
        </div>
    </div>
</template>
